'use client';
import styled from 'styled-components';
import {
  Content,
  ContentContainer,
  BackgroundImage,
  Subheader,
  StyledHero,
} from '@web/components/Hero/styles';

export const StyledCheckoutConfirmationContainer = styled.main`
  min-height: 100vh;
  overflow: hidden;
  background: ${props => props.theme.colors.background.base};
`;

export const Container = styled.div`
  max-width: 1280px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);

  @media ${props => props.theme.tabletS} {
    margin: ${props => props.theme.spacing(10, 20)};
  }

  @media ${props => props.theme.laptop} {
    margin: ${props => props.theme.spacing(8)} auto 72px;
    display: flex;
    flex-direction: row;
    gap: ${props => props.theme.spacing(4)};
  }
`;

export const LeftSideWrapper = styled.div`
  grid-area: 1 / 1 / 2 / 2;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${props => props.theme.spacing(4, 4, 0)};

  @media ${props => props.theme.tabletS} {
    padding: ${props => props.theme.spacing(4, 4)};
  }

  @media ${props => props.theme.laptop} {
    width: 75%;
    padding: 0;
  }
`;

export const RightSideWrapper = styled.div`
  grid-area: 2 / 1 / 3 / 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100vw;
  padding: ${props => props.theme.spacing(0, 4, 4)};
  margin-bottom: ${props => props.theme.spacing(4)};
  @media ${props => props.theme.laptop} {
    width: 45%;
    padding: 0;
  }
  @media ${props => props.theme.laptopL} {
    width: 30%;
  }
`;

export const MobileGetSocialWrapper = styled.div`
  display: block;
  grid-area: 3 / 1 / 4 / 2;
  width: 100%;
  margin-bottom: ${props => props.theme.spacing(16)};
  @media ${props => props.theme.laptop} {
    width: auto;
    display: none;
  }
`;
export const DesktopGetSocialWrapper = styled.div`
  display: none;
  @media ${props => props.theme.laptop} {
    display: block;
  }
`;

export const HeroContainer = styled.div`
  ${StyledHero} {
    background-color: #798c7a;
  }

  ${BackgroundImage} {
    max-height: 490px;
    img {
      object-fit: cover;
    }
  }

  ${ContentContainer} {
    margin-top: ${props => props.theme.spacing(20)};
  }
  ${Content} {
    position: absolute;
    left: 0;
    top: 45%;
    align-items: center;
    text-align: center;
    p {
      max-width: 100vw;
    }
    padding: ${props => props.theme.spacing(0, 4, 2)};
  }

  ${Subheader} {
    max-width: 100%;
  }

  @media ${props => props.theme.mobileM} {
    overflow: hidden;
    ${Content} {
      top: auto;
      bottom: 0;
    }
  }
  @media ${props => props.theme.tabletS} {
    ${BackgroundImage} {
      max-height: 100%;
      padding: 0;
      height: 100%;

      img {
        max-height: 100%;
        min-width: 100vw;
        min-height: 10px;
      }
    }

    ${Content} {
      position: static;
      text-align: left;
      align-items: start;
      padding: 0;
      margin: ${props => props.theme.spacing(4)};
      p {
        margin-bottom: 0;
      }
    }

    ${Subheader} {
      width: 60%;
    }
  }

  @media ${props => props.theme.tablet} {
    ${ContentContainer} {
      margin: ${props => props.theme.spacing(0, 4)};
    }
  }
  @media ${props => props.theme.tablet} {
    ${Content} {
      padding: ${props => props.theme.spacing(10)};
    }
  }

  @media ${props => props.theme.laptopL} {
    ${Subheader} {
      width: 100%;
    }
  }
`;
